import { type TColumn } from "components/EditableTable/types";

// Sales-specific column key type
export type SalesColumnKey =
    | "importIndex"
    | "input_date"
    | "input_ean13"
    | "input_channelId"
    | "input_qty"
    | "input_revenue"
    | "input_turnover_1"
    | "input_turnover_2"
    | "input_returnedSales"
    | "input_countryMarket"
    | "input_distributorInvoicingPercentage"
    | "input_overridenPrice"
    | "input_overridenPriceCurrency"
    | "input_note"
    | "input_source"
    | "input_collectiveManagementKind"
    | "input_isDeleted";

// Sales-specific columns configuration
export const SALES_COLUMNS_CONFIG: TColumn[] = [
    { key: "importIndex", label: "importIndex", size: 50 },
    { key: "input_date", label: "input_date", size: 120 },
    { key: "input_ean13", label: "input_ean13", size: 150 },
    { key: "input_channelId", label: "input_channelId", size: 100 },
    { key: "input_qty", label: "input_qty", size: 150 },
    { key: "input_revenue", label: "input_revenue", size: 150 },
    { key: "input_turnover_1", label: "input_turnover_1", size: 150 },
    { key: "input_turnover_2", label: "input_turnover_2", size: 150 },
    { key: "input_returnedSales", label: "input_returnedSales", size: 150 },
    { key: "input_countryMarket", label: "input_countryMarket" },
    { key: "input_distributorInvoicingPercentage", label: "input_distributorInvoicingPercentage", size: 150 },
    { key: "input_overridenPrice", label: "input_overridenPrice", size: 100 },
    { key: "input_overridenPriceCurrency", label: "input_overridenPriceCurrency", size: 100 },
    { key: "input_note", label: "input_note" },
    { key: "input_source", label: "input_source" },
    { key: "input_collectiveManagementKind", label: "input_collectiveManagementKind", size: 150 },
    { key: "input_isDeleted", label: "input_isDeleted", size: 20, isHidden: true },
];

// Type for sales table row based on the columns config
export type SalesEditableTableRow = {
    id: string;
    columns: {
        [P in (typeof SALES_COLUMNS_CONFIG)[number]["key"]]?: {
            value: string;
            isModified?: boolean;
            initialValue?: string;
            isEditable?: boolean;
            helperText?: string;
            sx?: any;
        };
    };
};
